angular.module('FmsApp').factory("SoilSampleResource", function ($resource) {
    return $resource('/api/soil/sample/:id/', {id: '@id'}, {
        update: {method: 'PUT'} 
    });
});
